import { ClockIcon, ShoppingCartIcon } from '@heroicons/react/24/outline';
import TextWinds from '../../common/TextWinds';
import { VoucherItem } from '../../../constants/types/lms/voucher/type';
import { Button } from 'antd';
import { numberWithCommas } from '../../../api/utils/format/numbers';

interface VoucherListPanelProps {
  voucherList: VoucherItem[];
  selectedVoucherId: number;
  handleHistoryClick: (voucherId: number) => void;
  handlePurchaseClick: (voucher: VoucherItem) => void;
}

/**
 * 개편 LMS (교사) - 이용권 관리 페이지 > 이용권 현황 판넬
 */
const VoucherListPanel = ({
  voucherList,
  selectedVoucherId,
  handleHistoryClick,
  handlePurchaseClick,
}: VoucherListPanelProps) => {
  return (
    <div>
      <div className="mb-5 flex items-center justify-between">
        <TextWinds type="title_h3">이용권 현황</TextWinds>
      </div>

      <div className="flex flex-col gap-3">
        {voucherList.map((voucher) => {
          const isSelected = selectedVoucherId === voucher.id;

          return (
            <div
              key={voucher.id}
              className={[
                'rounded-xl border bg-white p-4 transition-shadow hover:shadow-sm',
                isSelected ? 'border-purple5' : 'border-gray3',
              ].join(' ')}
            >
              <div className="mb-4 flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <TextWinds type="content_body2" className="break-keep">
                    {voucher.name}
                  </TextWinds>
                </div>

                <div className="shrink-0 rounded-full bg-gray1 px-3 py-1">
                  <TextWinds type="caption1" color="gray8">
                    {numberWithCommas(voucher.voucherCount)}개
                  </TextWinds>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-2">
                <Button
                  type="default"
                  className={`flex items-center justify-center gap-1.5 rounded-lg !border-purple5 px-3 py-2 hover:!border-purple6 hover:!bg-purple1 ${
                    selectedVoucherId === voucher.id
                      ? '!border-purple6 !bg-purple1'
                      : ''
                  }`}
                  onClick={() => handleHistoryClick(voucher.id)}
                >
                  <ClockIcon className="h-4 w-4 text-purple5" />

                  <TextWinds type="caption1" color="purple5">
                    이용내역
                  </TextWinds>
                </Button>

                <Button
                  type="primary"
                  className="flex items-center justify-center gap-1.5 rounded-lg bg-purple5 px-3 py-2"
                  onClick={() => handlePurchaseClick(voucher)}
                >
                  <ShoppingCartIcon className="h-4 w-4 text-white" />

                  <TextWinds type="caption1" color="white">
                    구매하기
                  </TextWinds>
                </Button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default VoucherListPanel;
